/** ID entiteta iz verified/requested stavke (organizacija или институција). */
export function getEntityAccessId(entity) {
  return String(
    entity?.organization_id
    ?? entity?.organizationId
    ?? entity?.institution_id
    ?? entity?.institutionId
    ?? entity?.id
    ?? entity
  );
}

/**
 * Mapa ID → 'verified' | 'pending' за disable у selectу „Затражи приступ“.
 */
export function buildEntityAccessStatusMap(verified = [], requested = []) {
  const map = new Map();
  verified.forEach((entity) => {
    map.set(getEntityAccessId(entity), 'verified');
  });
  requested.forEach((entity) => {
    const id = getEntityAccessId(entity);
    if (!map.has(id)) map.set(id, 'pending');
  });
  return map;
}

/** Иконе и ознаке за verified / pending — исте у selectу, легенди и PendingCard. */
export const ACCESS_STATUS_META = {
  verified: {
    iconClass: 'fas fa-check',
    suffix: 'имате приступ',
  },
  pending: {
    iconClass: 'fas fa-clock',
    suffix: 'чека одобрење',
  },
};

export const ACCESS_STATUS_LEGEND_ITEMS = Object.entries(ACCESS_STATUS_META).map(([status, meta]) => ({
  status,
  ...meta,
}));

export function getOptionDisplayName(item) {
  return item?.name || item?.naziv || `ID ${item?.id}`;
}

export function formatRequestAccessOptionLabel(name, accessStatus) {
  const label = name || '';
  const meta = accessStatus ? ACCESS_STATUS_META[accessStatus] : null;
  if (!meta) return label;
  return `${label} — ${meta.suffix}`;
}
